import { useState } from "react";
import { Camera, Wrench, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { compressImage } from "../../lib/compressImage";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export function UsageDialog({ open, onOpenChange, stock, preset, onDone }) {
  const [form, setForm] = useState({ item_name: preset || "", qty: 1, location: "", note: "", paid: "gratis", amount: "" });
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const avail = stock.filter((s) => s.remaining > 0);
  const sel = stock.find((s) => s.name === form.item_name);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const fd = new FormData();
      Object.entries({ ...form, qty: Number(form.qty) || 1, amount: Number(form.amount) || 0 }).forEach(([k, v]) => fd.append(k, v));
      if (photo) fd.append("photo", await compressImage(photo), "bukti.jpg");
      await api.post("/asset-usages", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${form.item_name} × ${form.qty} tercatat terpasang di ${form.location}`);
      setForm({ item_name: "", qty: 1, location: "", note: "", paid: "gratis", amount: "" }); setPhoto(null);
      onOpenChange(false); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="dialog-asset-usage">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Wrench className="w-5 h-5 text-amber-500" /> Pasang / Gunakan Aset</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5"><Label>Nama Alat</Label>
            <Select value={form.item_name} onValueChange={(v) => setForm({ ...form, item_name: v })}>
              <SelectTrigger data-testid="usage-item"><SelectValue placeholder="Pilih alat dari stok..." /></SelectTrigger>
              <SelectContent>{avail.map((s) => <SelectItem key={s.name} value={s.name} data-testid={`usage-item-opt-${s.name.replace(/\W+/g, "-")}`}>{s.name} (sisa {s.remaining})</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Jumlah</Label><Input type="number" min="1" max={sel?.remaining || 1} required value={form.qty} onChange={(e) => setForm({ ...form, qty: e.target.value })} data-testid="usage-qty" />
              {sel && <p className="text-[10px] text-muted-foreground">Sisa stok: {sel.remaining}</p>}</div>
            <div className="space-y-1.5"><Label>Pemasangan</Label>
              <Select value={form.paid} onValueChange={(v) => setForm({ ...form, paid: v })}>
                <SelectTrigger data-testid="usage-paid"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="gratis" data-testid="usage-paid-gratis">Gratis</SelectItem><SelectItem value="berbayar" data-testid="usage-paid-berbayar">Berbayar</SelectItem></SelectContent>
              </Select>
            </div>
          </div>
          {form.paid === "berbayar" && <div className="space-y-1.5"><Label>Biaya Pemasangan (Rp)</Label><Input type="number" min="0" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} placeholder="cth: 150000" data-testid="usage-amount" /></div>}
          <div className="space-y-1.5"><Label>Dipasang di mana</Label><Input required value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} placeholder="cth: Rumah Bpk Andi, Cabang JESSY.NET" data-testid="usage-location" /></div>
          <div className="space-y-1.5"><Label>Keterangan</Label><Textarea rows={2} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="opsional" data-testid="usage-note" /></div>
          <div className="space-y-1.5"><Label>Foto Bukti Pemasangan <span className="text-muted-foreground font-normal">(opsional, untuk verifikasi admin)</span></Label>
            {photo ? (
              <div className="relative inline-block"><img src={URL.createObjectURL(photo)} alt="bukti" className="h-24 rounded-lg border border-border object-cover" data-testid="usage-photo-preview" />
                <button type="button" onClick={() => setPhoto(null)} className="absolute -top-2 -right-2 bg-rose-500 text-white rounded-full p-0.5" data-testid="usage-photo-remove"><X className="w-3 h-3" /></button></div>
            ) : (
              <label className="flex items-center gap-2 rounded-lg border border-dashed border-border px-3 py-2.5 text-xs text-muted-foreground cursor-pointer hover:border-amber-500/50" data-testid="usage-photo-label">
                <Camera className="w-4 h-4" /> Ambil / pilih foto<input type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => setPhoto(e.target.files?.[0] || null)} data-testid="usage-photo-input" />
              </label>
            )}
          </div>
          <Button type="submit" disabled={busy || !form.item_name} className="w-full bg-amber-500 hover:bg-amber-600 text-white" data-testid="usage-submit">{busy ? "Menyimpan..." : "Catat Pemasangan"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
